import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Census from "../components/Census";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import RealRescues from "../components/RealRescues";
import VideoSection from "../components/VideoSection";
import Stories from "../components/Stories";
import SisterProject from "../components/SisterProject";
import Volunteer from "../components/Volunteer";
import Contact from "../components/Contact";
import Supporters from "../components/Supporters";
import Footer from "../components/Footer";
import ButterflyCursor from "../components/cosmic/ButterflyCursor";

export default function HomePage() {
  return (
    <>
      <ButterflyCursor />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Census />
        <About />
        <Services />
        <Gallery />
        <RealRescues />
        <VideoSection />
        <Stories />
        <SisterProject />
        <Volunteer />
        <Contact />
        <Supporters />
      </main>
      <Footer />
    </>
  );
}
